import { z } from 'zod';

const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;

export const onboardingSchema = z
  .object({
    otp: z.string().regex(/^\d{6}$/, 'El código OTP debe ser de 6 dígitos.'),
    rfc: z
      .string()
      .min(1, 'El RFC es obligatorio')
      .max(13, 'Máximo 13 caracteres')
      .or(z.literal('')),
    curp: z
      .string()
      .trim()
      .toUpperCase()
      .length(18, 'La CURP debe tener exactamente 18 caracteres.'),
    rfc: z
      .string()
      .trim()
      .toUpperCase()
      .refine((value) => !value || /^[A-Z0-9Ñ&]{12,13}$/.test(value), {
        message: 'El RFC debe tener 12 o 13 caracteres alfanuméricos.',
      }),
    password: z
      .string()
      .min(8, 'La contraseña debe tener al menos 8 caracteres.')
      .regex(PASSWORD_REGEX, 'Debe incluir mayúscula, minúscula, número y carácter especial.'),
    confirmPassword: z.string().min(1, 'Confirma la contraseña.'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Las contraseñas no coinciden.',
    path: ['confirmPassword'],
  });
